var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
import * as React from 'react';
import MuiIconButton, { iconButtonClasses } from '@mui/material/IconButton';
import { styled } from '../styled';
import { useIconButtonContext } from './icon-button-context';
export var IconButtonComponentName = 'QuantumIconButton';
export { iconButtonClasses };
// using any here to work arround TS perf issues with OverrideableComponent and styled
var Root = styled(MuiIconButton, {
    name: IconButtonComponentName,
    slot: 'Root',
})(function (_a) {
    var _b;
    var theme = _a.theme, edge = _a.edge, ownerState = _a.ownerState, color = _a.color;
    return (__assign(__assign(__assign({}, (edge === 'end' && __assign({ marginRight: -11 }))), (_b = { '&:focus,&.Mui-focusVisible': color === 'danger'
                ? theme.mixins.focusRing({ color: theme.tokens.color_border_focus_state_danger })
                : theme.mixins.focusRing(), padding: 0, borderRadius: '4px', transition: theme.transitions.create(['background-color', 'box-shadow', 'border-color', 'color'], {
                duration: theme.transitions.duration.short,
            }) }, _b["&.".concat(iconButtonClasses.disabled)] = {
        backgroundColor: theme.palette.action.disabledBackground,
        color: theme.tokens.color_fg_default,
    }, _b['& > svg:first-child'] = {
        height: '1em',
        width: '1em',
    }, _b)), (ownerState.shape === 'circular' && {
        borderRadius: '50%',
    })));
});
export var IconButton = React.forwardRef(function (props, ref) {
    var iconButtonContext = useIconButtonContext();
    var children = props.children, _a = props.color, color = _a === void 0 ? 'default' : _a, _b = props.variant, variant = _b === void 0 ? 'link' : _b, _c = props.size, size = _c === void 0 ? 'medium' : _c, disabled = props.disabled, edgeProp = props.edge, _d = props.shape, shape = _d === void 0 ? 'default' : _d, iconButtonProps = __rest(props, ["children", "color", "variant", "size", "disabled", "edge", "shape"]);
    var edge = edgeProp != null ? edgeProp : iconButtonContext.edge;
    return (React.createElement(Root, __assign({ color: color, ref: ref, edge: edge, disabled: disabled, size: size, variant: variant, ownerState: { shape: shape } }, iconButtonProps), children));
});
